import React, { FC, useCallback, useContext } from 'react';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import { Button } from 'ncoded-component-library';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import BurgerIcon from 'icons/Burger.icon';
import { ViewSelectProp } from 'models/User';
import GridIcon from 'icons/Grid.icon';
import useMatchMedia from 'hooks/useMatchMedia';

import './ViewSelect.styles.scss';

type ViewSelectProps = {
  className?: string;
  isTableView?: boolean;
  updateProp: ViewSelectProp;
};

const ViewSelect: FC<ViewSelectProps> = ({
  className,
  isTableView,
  updateProp,
}) => {
  const classes = classNames('view-select', className);

  const { updateView } = useContext(CurrentUserContext);

  const { t } = useTranslation();

  const isPhablet = useMatchMedia('isPhablet');

  const update = useCallback(
    (isTableView: boolean) => updateView(updateProp, !isTableView),
    [updateProp, updateView],
  );

  return (
    <Button
      className={classes}
      icon={isTableView ? GridIcon : BurgerIcon}
      onClick={() => update(isTableView ? false : true)}
    >
      {!isPhablet && t(isTableView ? 'cardView' : 'tableView')}
    </Button>
  );
};

export default ViewSelect;
